import React from 'react';

import { useTranslation } from '../../../../../../hooks';
import { T } from '../../../../../../constants';

import CoinLeft from '../../../../../../assets/images/coint-left.png'
import CoinRight from '../../../../../../assets/images/coin-right.png'

import './style.scss';

interface AnnouncementSmallPopupProps {
  onClose: () => void;
}

export const AnnouncementSmallPopup: React.FC<AnnouncementSmallPopupProps> = ({ onClose }) => {

  const t = useTranslation();

  return (
    <div className="announcement-small-popup-container">
      <div className="announcement-small-popup-decor"></div>
      <div className="announcement-small-popup-wrapper">

        <button type="button" className="announcement-small-popup-close" onClick={onClose}>
          <i className="icon-close " />
        </button>

        <div className="announcement-small-popup">
          <div className="announcement-small-popup-header">
            <p className="announcement-small-popup-title">{t(T.PASCAL_REWARDS)}</p>
          </div>

          <div className="announcement-small-popup-section">
            <div className="announcement-small-popup-item">
              <span className="announcement-small-popup-label">{t(T.PLAY)}</span>
              <span className="announcement-small-popup-desc">{t(T.BET_ON_ELIGIBLE_GAMES)}</span>
            </div>
            <div className="announcement-small-popup-item">
              <span className="announcement-small-popup-label">{t(T.LEVEL_UP)}</span>
              <span className="announcement-small-popup-desc">{t(T.FILL_YOUR_PROGRESS_BAR)}</span>
            </div>
            <div className="announcement-small-popup-item">
              <span className="announcement-small-popup-label">{t(T.GET_PRIZES)}</span>
              <span className="announcement-small-popup-desc">{t(T.UNLOCK_CASH_AND_FREE_SPINS)}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="announcement-small-popup-coin">
        <img src={CoinLeft} alt="coin" className="announcement-small-popup-coin-img" />
        <img src={CoinRight} alt="coin" className="announcement-small-popup-coin-img" />
      </div>
    </div>
  );
};